<ng-container [ngSwitch]="partnerType">
  <ng-container *ngSwitchCase="installmentTypes.BANKS">
    <app-bank-partners
      [isDesktop]="isDesktop"
      [searchBy]="searchBy"
      [totalPrice]="totalPrice"
      [maxAmount]="maxAmount"
      [showSwipeUp]="showSwipeUp"
      (closeModal)="closeModal.emit()">
    </app-bank-partners>
  </ng-container>
  <ng-container *ngSwitchCase="installmentTypes.CARDS">
    <app-card-partners
      [isDesktop]="isDesktop"
      [totalPrice]="totalPrice"
      [maxAmount]="maxAmount"
      [showSwipeUp]="showSwipeUp"
      (closeModal)="closeModal.emit()">
    </app-card-partners>
  </ng-container>
</ng-container>
